import React, { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import cost_design_icon from "../assets/svg/cost_design_icon.svg";
import computer_icon from "../assets/svg/computer-icon.png";
import leftmove from "../assets/svg/leftmove_arrow.svg";
import '../styles/LoginPage.css';
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import lentera from "../assets/svg/lentera-icon.svg";

const VerifyCode = () => {
    const [code, setCode] = useState(new Array(6).fill(""));
    const [loading, setLoading] = useState(false);
    const inputRefs = useRef([]);
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email;

    // Handle input typing
    const handleChange = (value, index) => {
        if (/^[0-9]?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);

            // Move focus to next box
            if (value && index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    // Handle backspace
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !code[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    // Verify code API call
    const handleVerifyCode = async () => {
        const enteredCode = code.join("");
        if (enteredCode.length !== 6) {
            toast.error("Please enter the 6-digit verification code");
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post("/verifyCode", {
                email,
                code: enteredCode,
            });

            if (response.data.success) {
                toast.success("Code verified successfully!");
                setTimeout(() => {
                    navigate("/resetPassword", { state: { token: response.data.token } });
                }, 1500);
            } else {
                toast.error(response.data.message || "Invalid verification code");
            }
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Failed to verify code");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="login-page">
                <div className="left-panel">
                    <div className="logo">
                        <img src={cost_design_icon} alt="" className="cost-design-icon" />
                        <span>WBS</span>
                    </div>
                    <h2>
                        PRECISION WAREHOUSE BILLING MADE <br /> SIMPLE
                    </h2>
                    <div className="laptop-container">
                        <img src={computer_icon} alt="Laptop Hand" className="laptop-image" />
                        <div className="laptop-shadow"></div>
                    </div>
                </div>

                <div className="right-panel">
                    <img
                        src={leftmove}
                        onClick={() => navigate(-1)}
                        style={{ width: '30px', height: '30px', marginBottom: '10px', cursor: 'pointer' }}
                        alt=""
                    />
                    <h2>Verify your Email Address</h2>
                    <p>We sent a verification code to {email || "your email"}</p>

                    <div className="login-form" style={{ marginTop: '15px' }}>
                        <label>
                            Verification Code <span style={{ color: 'red' }}>*</span>
                        </label>

                        <div
                            style={{
                                display: "flex",
                                marginTop: '10px',
                                gap: '30px'
                            }}
                        >
                            {code.map((digit, index) => (
                                <input
                                    key={index}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleChange(e.target.value, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    className="verify-code-box"
                                    style={{
                                        width: "45px",
                                        height: "40px",
                                        textAlign: "center",
                                        fontSize: "16px",
                                        border: "1px solid #E0E0E0",
                                        borderRadius: "8px",
                                        outline: "none",
                                        margin: '0px'
                                    }}
                                />
                            ))}
                        </div>

                        <button
                            type="button"
                            className="sign-in-button"
                            onClick={handleVerifyCode}
                            disabled={loading}
                        >
                            {loading ? "Verifying..." : "Verify Code"}
                        </button>
                    </div>

                    <p style={{ marginTop: "20px", cursor: "pointer" }}>
                        By submitting, you agree to our <span style={{ color: '#097BED' }}>Terms & Conditions</span>
                    </p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "16px",
                        }}
                    >
                        <span>{new Date().getFullYear()} © Powered by</span>
                        <a href="https://lenteratech.com/" target="_blank" rel="noreferrer">
                            <img
                                src={lentera}
                                alt="Lentera"
                                style={{
                                    height: "14px",
                                    display: "block",
                                }}
                            />
                        </a>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default VerifyCode;
